import { formatTime } from "./utils";
import "./style.scss";
import { useCountdown } from "./hooks";

export const CountdownTimer = ({
  countdownTime,
}: {
  countdownTime: number;
}) => {
  const { timeRemaining } = useCountdown(countdownTime);

  return (
    <div className="countdown-timer">
      <span className="timer-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M14.6562 14.2262V7.18247C14.6562 6.65747 14.2187 6.21997 13.6937 6.21997C13.1687 6.21997 12.7312 6.65747 12.7312 7.18247V14.62C12.7312 14.8825 12.8187 15.145 12.9937 15.32L17.85 20.2637C18.025 20.4387 18.2875 20.57 18.55 20.57C18.8125 20.57 19.0312 20.4825 19.25 20.3075C19.6437 19.9137 19.6437 19.3012 19.25 18.9075L14.6562 14.2262Z"
            fill="currentColor"
          />
          <path
            d="M14 0.444946C6.69373 0.444946 0.787476 6.4387 0.787476 13.7887C0.787476 21.1387 6.73748 27.1324 14 27.1324C21.2625 27.1324 27.2125 21.1387 27.2125 13.7887C27.2125 6.4387 21.3062 0.444946 14 0.444946ZM14 25.1637C7.78748 25.1637 2.71248 20.0449 2.71248 13.7887C2.71248 7.53245 7.78748 2.4137 14 2.4137C20.2125 2.4137 25.2875 7.53245 25.2875 13.7887C25.2875 20.0449 20.2125 25.1637 14 25.1637Z"
            fill="currentColor"
          />
        </svg>
      </span>
      <span className="timer-display">
        {formatTime(Math.max(0, timeRemaining))}
      </span>
    </div>
  );
};
